<template>
    <ValidationObserver
        ref="printA4Labels"
        v-slot="{ passes}"
    >
        <BaseDialog
            :showDialog="showDialog"
            headline="lang_AZ_PERSONS_CAPTION_PRINT_ADDRESS_LABELS"
            :close="closeDialog"
            maxDialogWidth="600"
            maxCardHeight="700"
            :alvqa="alvqa"
        >
            <template v-slot:dialogText>
                <v-container fluid>
                    <v-row>
                        <v-col>
                            <BaseEditPageTextField 
                                :context="context"
                                field="NumberOfColumns"
                                :label="$t('lang_AZ_PERSONS_CAPTION_NUMBER_OF_COLUMNS')"
                                :withMargin="false"
                                :alvqa="alvqa + '-textfield-number-of-columns'"
                                rules="integerMinMax:2,5"
                            />
                        </v-col>
                        <v-col>
                            <BaseEditPageTextField 
                                :context="context"
                                field="NumberOfRows"
                                :label="$t('lang_AZ_PERSONS_CAPTION_NUMBER_OF_ROWS')"
                                :withMargin="false"
                                :alvqa="alvqa + '-textfield-number-of-rows'"
                                rules="integerMinMax:4,12"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <BaseEditPageTextField 
                                :context="context"
                                field="LabelWidth"
                                :label="$t('lang_AZ_PERSONS_CAPTION_LABEL_WIDTH')"
                                :withMargin="false"
                                :alvqa="alvqa + '-textfield-label-width'"
                                suffix="mm"
                                rules="integerMinMax:42,105"
                                
                            />
                        </v-col>
                        <v-col>
                            <BaseEditPageTextField 
                                :context="context"
                                field="LabelHeight"
                                :label="$t('lang_AZ_PERSONS_CAPTION_LABEL_HEIGHT')"
                                :withMargin="false"
                                :alvqa="alvqa + '-textfield-label-height'"
                                suffix="mm"
                                rules="integerMinMax:25,75"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <BaseEditPageTextField 
                                :context="context"
                                field="TopMargin"
                                :label="$t('lang_AZ_PERSONS_CAPTION_TOP_MARGIN')"
                                :withMargin="false"
                                :alvqa="alvqa + '-textfield-top-margin'"
                                suffix="mm"
                                rules="integerMinMax:0,30"
                            />
                        </v-col>
                        <v-col>
                            <BaseEditPageTextField 
                                :context="context"
                                field="LeftMargin"
                                :label="$t('lang_AZ_PERSONS_CAPTION_LEFT_MARGIN')"
                                :withMargin="false"
                                :alvqa="alvqa + '-textfield-left-margin'"
                                suffix="mm"
                                rules="integerMinMax:0,20"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <BaseEditPageTextField 
                                :context="context"
                                field="PrintTagMarking"
                                :label="$t('lang_AZ_PERSONS_CAPTION_PRINT_TAG_MARKING')"
                                :withMargin="false"
                                :alvqa="alvqa + '-textfield-print-tag.marking'"
                            />
                        </v-col>
                        <v-col>
                            <BaseEditPageTextField 
                                :context="context"
                                field="SenderLine"
                                :label="$t('lang_AZ_PERSONS_CAPTION_SENDER_LINE')"
                                :withMargin="false"
                                :alvqa="alvqa + '-textfield-sender-line'"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <BaseEditPageTextField 
                                :context="context"
                                field="SizeSender"
                                :label="$t('lang_AZ_PERSONS_CAPTION_FONT_SIZE_SENDER')"
                                :withMargin="false"
                                :alvqa="alvqa + '-textfield-size-sender'"
                                suffix="pt"
                                rules="integerMinMax:1,50"
                            />
                        </v-col>
                        <v-col>
                            <BaseEditPageTextField 
                                :context="context"
                                field="SizeAddress"
                                :label="$t('lang_AZ_PERSONS_CAPTION_FONT_SIZE_ADDRESS')"
                                :withMargin="false"
                                :alvqa="alvqa + '-textfield-size-address'"
                                suffix="pt"
                                rules="integerMinMax:1,50"
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </template>
            <template v-slot:dialogActions>
                <v-container fluid>
                    <v-row>
                        <v-spacer />
                        <v-col class="text-right">
                            <BaseButton 
                                label="lang_GENERAL_BUTTON_CAPTION_CREATE_PDF"
                                @click="passes(create)"
                                :alvqa="alvqa+'-button-create'"
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </template>
        </BaseDialog>
    </ValidationObserver>
</template>

<script>
import BaseDialog from '@/components/_base/BaseDialog'
import BaseButton from '@/components/_buttons/BaseButton'
import BaseEditPageTextField from '@/components/_editForm/BaseEditPageTextField'

export default {
    name: "PrintAzPersonsA4LabelsDialog",
    components: {
        BaseDialog,
        BaseButton,
        BaseEditPageTextField
    },
    data() {
        return {
            alvqa: 'az-persons-list-dialog-print-a4-labels',
            context: 'PrintAzPersonsA4LabelsForm'
        }
    },
    computed: {
        showDialog: {
            get() { return this.$store.getters.getPrintAzPersonsA4LabelsDialog },
            set(show) { this.$store.commit('setPrintAzPersonsA4LabelsDialog', show) }
        }
    }, 
    methods: {
        closeDialog() {
            this.showDialog = false
        },
        create() {
            this.$store.dispatch('createAddressLabelsPDF')
            this.closeDialog()
        }
    }
}
</script>